import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { EmailAccount } from "../Entities/EmailAccount/EmailAccount";
import { EmailAccountInterface } from "../Entities/EmailAccount/EmailAccountInterface";

class EmailAccountFactory extends Factory implements FactoryInterface {

  public create(data: any): EmailAccountInterface {
    return new EmailAccount({
      id: data.id,
      removed: data.removed,
      personId: data.userId,
      agencyId: data.agencyId,
      imapUser: data.imapUser,
      imapPassword: data.imapPassword,
      imapHost: data.imapHost,
      imapPort: data.imapPort,
      imapTls: data.imapTls,
      lastTimeParsed: data.lastTimeParsed,
      active: data.active,
      valid: data.valid,
      reason: data.reason,
      providerId: data.providerId
    });
  }

  public reinitialize(data: any): EmailAccountInterface {
    return new EmailAccount({
      ...data
    });
  }
}

export default new EmailAccountFactory();
